import {Directive, Output, ElementRef, EventEmitter} from '@angular/core';

@Directive({
    selector: '[overslide]',
    host: {'(ionDrag)': 'handleDrag($event)'}
})

export class OverslideDirective {

    triggered: boolean;

    @Output() overslide: any = new EventEmitter();

    constructor(public element: ElementRef) {

    }

    handleDrag(ev) {

        if (Math.abs(ev.getSlidingPercent()) > 1.7 && !this.triggered) {

            this.triggered = true;

            this.element.nativeElement.style.transition = '0.3s linear';
            this.element.nativeElement.style.opacity = '0';

            setTimeout(() => {
                this.element.nativeElement.style.display = 'none';
                this.overslide.emit({
                    cancelOverslide: () => {
                        return this.cancelOverslide(ev)
                    }
                });
            }, 500);

        }

    }

    cancelOverslide(ev) {

        this.triggered = false;

        this.element.nativeElement.style.transition = '0s linear';
        this.element.nativeElement.style.display = 'block';
        this.element.nativeElement.style.opacity = '1';

        ev.close();

    }

}



// WEBPACK FOOTER //
// ./src/directives/overslide.ts